export default null;throw new Error("Unable to resolve \"./crc32\" from npm:pngjs@5.0.0/browser.js");